import React from 'react';

export interface IModalContext {
    variant?: 'light';
    isSubmitting: boolean;
    onCancel: () => void;
}

export const ModalContext = React.createContext<IModalContext>({
    variant: undefined,
    isSubmitting: false,
    onCancel: () => {
        return;
    },
});
